export const colors = {
  white: '#FFF',
  whiteHover: '#CCCCCC',
  white3: '#EFEDE6',
  black: '#000',
  blackHover: '#4D4D4D',
};
